
import service from '@/service/chat_api'
import jzbApiList from "../service/basic/jzbApiList";
const myhost = myhostname;


/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description r4gys查询总行
 */
export function r4gysGetBank (params) {

  return new Promise((resolve, reject) => {
    service.get(`${myhost}${jzbApiList.r4gys_getBank}`, {
      params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description r4gys市列表
 */
export function r4gysAddressCity (params) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${jzbApiList.r4gys_addressCity}`, {
      params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description r4gys查询支行
 */
export function r4gysGetBranchBank (params) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${jzbApiList.r4gys_getBranchBank}`, {
      params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description r4gys对私-发送验证码
 */
export function r4gysGetPersonalCheck (params) {
  return new Promise((resolve, reject) => {
    service.post(`${myhost}${jzbApiList.r4gys_getPersonalCheck}`, params).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description r4gys对私-绑定银行卡
 */
export function r4gysGetPersonaBind (params) {
  return new Promise((resolve, reject) => {
    service.post(`${myhost}${jzbApiList.r4gys_getPersonaBind}`, {
      params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description r4gys对公-获取额度
 */
export function r4gysEnterpriseCheck (params) {
  return new Promise((resolve, reject) => {
    service.post(`${myhost}${jzbApiList.r4gys_enterpriseCheck}`, {
      params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description r4gys对公-绑定银行卡
 */
export function r4gysEnterpriseBind (params) {
  return new Promise((resolve, reject) => {
    service.post(`${myhost}${jzbApiList.r4gys_enterpriseBind}`, {
      params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description r4gys省列表
 */
export function r4gysGetProvince (params) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${jzbApiList.r4gys_getProvince}`, {
      params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description r4gys解绑
 */
export function r4gysAccountUnBind (params) {
  return new Promise((resolve, reject) => {
    service.put(`${myhost}${jzbApiList.r4gys_accountUnBind}`, params).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description r4gys获取全部公司
 */
export function r4gysCorpList (params) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${jzbApiList.r4gys_corpList}`, {
      params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description r4gys交易记录查询
 */
export function r4gysSettleTransaction (params) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${jzbApiList.r4gys_settleTransaction}`, {
      params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description r4gys交易明细记录查询
 */
export function r4gysSettleTransactionDetail (params) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${jzbApiList.r4gys_settleTransactionDetail}`, {
      params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description r4gys获取银行卡信息
 */
export function r4gysGetBankInfo (params) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${jzbApiList.r4gys_getBankInfo}`, {
      params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * @export 个人鉴权 todo
 * @param {*} params
 * @returns Prmoise
 *
 */
export function r4gysPersonInfoAuth (params) {
  return new Promise((resolve, reject) => {
    service.post(`${myhost}${jzbApiList.r4gys_personInfoAuth}`, {
      params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
/**
 * @export 企业鉴权 todo
 * @param {*} params
 * @returns Prmoise
 *
 */
export function r4gysCompanyInfoAuth (params) {
  return new Promise((resolve, reject) => {
    service.post(`${myhost}${jzbApiList.r4gys_companyInfoAuth}`, {
      params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
/**
 * @export r4gys提现页面信息
 * @param {*} params
 * @returns Prmoise
 *
 */
export function r4gysCashInfo (params) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${jzbApiList.r4gys_cashInfo}`, {
      params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
/**
 * @export r4gys发送验证码
 * @param {*} params
 * @returns Prmoise
 *
 */
export function r4gysVerifyCode (params) {
  return new Promise((resolve, reject) => {
    service.post(`${myhost}${jzbApiList.r4gys_verifyCode}`, params).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * @export r4gys提现
 * @param {*} params
 * @returns Prmoise
 *
 */
export function r4gysWithdraw (params) {
  return new Promise((resolve, reject) => {
    service.post(`${myhost}${jzbApiList.r4gys_withdraw}`, params).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/models/r4UserModel.js